import React from "react";
import "./Assets/Scss/Style.scss";
import { BrowserRouter as Router, Routes, Route, Outlet, } from "react-router-dom";
import Login from "./Public/Users/Login";
import Index from "./Public/HomePage/Index";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import Dashboard from "./Private/Dashboard";
import { title } from "./config/Config";
import Contact from "./Public/Contact";
import Blog from "./Public/Blog";
import Team from "./Public/Team";
import Portfolio from "./Public/Portfolio";
import About from "./Public/About";
import Services from "./Public/Services";
import WordPress from "./Public/WordPress";
import WebDesign from "./Public/WebDesign";

import WebDeveloper from "./Public/WebDeveloper";
import WebHosting from "./Public/WebHosting";
import SearchEngine from "./Public/SearchEngine";
import EmailHosting from "./Public/EmailHosting";
// import MobileApp from "./Public/MobileApp";
import SmoothScroll from "./Layout/SmoothScroll";

function App() {
  // ? Login page.....
  function LoginLayout() {
    return (
      <>
        <Outlet />
      </>
    );
  }

  // Public page.....
  function PublicLayout() {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  }

  // Only Private page.....
  function PrivateLayout() {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  }

  return (
    <>
      <Router>
      <SmoothScroll />
        <Routes>
          
          {/* header and footer is removed this layout */}
          <Route element={<LoginLayout />}>
            <Route path="/login" element={<Login pageTitle={`Login | ${title}`} />} />
          </Route>

          {/* All Public pages___ */}
          <Route element={<PublicLayout />}>
            <Route path="*" element={<Index />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/Team" element={<Team />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/wordpress" element={<WordPress />} />
            <Route path="/web-design" element={<WebDesign />} />
            <Route path="/webdeveloper" element={<WebDeveloper />} />
            <Route path="/webhosting" element={<WebHosting />} />
            <Route path="/search-engine" element={<SearchEngine />} />
            {/* <Route path="/mobile-app" element={<MobileApp />} /> */}

            <Route path="/email-hosting" element={<EmailHosting />} />
          </Route>

          {/* All Public pages___ */}
          <Route element={<PrivateLayout />}>
            <Route path="/dashboard" element={<Dashboard pageTitle={`Dashboard | ${title}`} />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
